import {
  Grid,
  Box,
  Typography,
  CircularProgress,
  Container,
} from '@mui/material'
import React, { useEffect, useState, useRef, useCallback } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useNavigate, useParams } from 'react-router-dom'
import MuiAccordion from '@mui/material/Accordion'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import { styled } from '@mui/material/styles'
import ArrowIconRight from '../../Assets/Icons/Arrow_Small_Right.svg'
import PDFIcon from '../../Assets/Icons/PDF_Icon.svg'
import XLSXIcon from '../../Assets/Icons/XL_Icon.svg'
import DOCIcon from '../../Assets/Icons/Doc_Icon.svg'
import UnknownFile from '../../Assets/Icons/document_icon.svg'
import '../../Styles/Naac.css'
import { fetchData } from '../../Assets/API/apiservices'
import { useLocation } from 'react-router-dom'
import { ORGANIZATION_ID, SUB_ORGANIZATION_ID } from '../../Config/Config'

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
  color: theme.palette.mode === 'dark' ? '#fff' : 'black',
}))

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <img
        src={ArrowIconRight}
        loading="lazy"
        placeholder="blur"
        alt="Arrow Icon"
      />
    }
    {...props}
  />
))(({ theme }) => ({
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
    backgroundColor: theme.palette.mode === 'dark' ? '#ffff' : '#eeee',
    borderRadius: '50%',
  },
}))

const NACCExtended = () => {
  const [expanded, setExpanded] = useState(0)
  const [headingData, setHeadingData] = useState([])
  const [subHeadingData, setSubHeadingData] = useState([])
  const [selectedNaccData, setSelectedNaccData] = useState([])
  const [selectedsubHeading, setSelectedsubHeading] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const isMounted = useRef(true)
  const navigate = useNavigate()
  const parms = useParams()
  const location = useLocation()
  const NACCExtended_DATA = headingData?.naac_extended_headings
  const NACCSubheadingData = subHeadingData.NaacExtended_Data
  const SubheadingData = selectedsubHeading.ExternalID
  const expand_id = location.state?.expand_id

  const orgId = parseInt(ORGANIZATION_ID, 10) || 10
  const subOrgId = parseInt(SUB_ORGANIZATION_ID, 10) || 12
  const getHeadingData = async () => {
    try {
      const result = await fetchData('naacdetails/4')
      // setExpanded(result.naac_extended_headings[0].ID)
      return result
    } catch (err) {
      toast.error(err.message)
    }
  }

  const getSubheadingData = useCallback(async () => {
    try {
      const result = await fetchData(
        `naacdetails/4?subheading=${SubheadingData}&organization_id=${orgId}&sub_organization_id=${subOrgId}`
      )
      return result
    } catch (err) {
      toast.error(err.message)
    }
  }, [SubheadingData]) // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    setExpanded(expand_id)
    handleSubheadingClick({ ExternalID: parms.id, Subheading: parms.name })
    const fetchInitialHeadingData = async () => {
      const heading = await getHeadingData()
      if (heading) {
        setHeadingData(heading)
        setExpanded(expand_id || heading.naac_extended_headings[0].ID)
      }
    }
    fetchInitialHeadingData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const fetchSubHeadingData = async () => {
      if (SubheadingData) {
        try {
          setIsLoading(true)
          const subHeading = await getSubheadingData()
          setTimeout(() => {
            if (subHeading) setSubHeadingData(subHeading)
            setIsLoading(false)
          }, 1000)
        } catch (error) {
          toast.error('Failed to load subheading data.')
          setIsLoading(false)
        }
      }
    }
    fetchSubHeadingData()
  }, [SubheadingData]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (index) => (event, newExpanded) => {
    setExpanded(newExpanded ? index : 0)
    if (newExpanded === true) {
      const selectedHeading =
        NACCExtended_DATA.find((data) => data.ID === index) || null
      if (selectedHeading && selectedHeading.SubHeading.length > 0) {
        handleSubheadingClick(selectedHeading.SubHeading[0])
      }
    }
  }

  const filterData = useCallback(
    (selected) => {
      if (!selected || !NACCSubheadingData) return
      const subheadingData = NACCSubheadingData.find(
        (data) => data.ID === String(selected.ID)
      )
      if (subheadingData && subheadingData.URLs) {
        setSelectedNaccData([subheadingData])
      } else {
        setSelectedNaccData([])
      }
      navigate(
        selectedsubHeading?.Subheading === 'Teacher'
          ? '/faculty'
          : `/NAACExtended/${
              selectedsubHeading?.ExternalID
            }/${selectedsubHeading?.Subheading?.replace(/\s/g, '-')}`,
        { state: { expand_id: expanded } }
      )
    },
    [NACCSubheadingData] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const handleSubheadingClick = async (subheading) => {
    if (!subheading) return
    setSelectedsubHeading(subheading)
    filterData(subheading)
    const subHeadingData = await getSubheadingData(subheading.ExternalID)
    if (subHeadingData) {
      setSubHeadingData(subHeadingData)
    }
  }

  useEffect(() => {
    const subheadingData = {
      ID: parseInt(parms.id),
      Subheading: parms.name,
    }
    filterData(subheadingData)
    return () => {
      isMounted.current = false
    }
  }, [NACCSubheadingData, filterData, parms.id, parms.name, NACCExtended_DATA])

  const handlePdfClick = (urldata) => {
    if (!urldata.pathurl.trim()) {
      toast.error('There is no file', {
        position: toast.POSITION.TOP_RIGHT,
      })
      return
    }
    navigate('/extendednaac/' + urldata.ExternalID + '/' + urldata.pathname, {
      state: { selectedDocData: urldata },
    })
  }

  const getFileIcon = (filename) => {
    const ext = filename.split('.').pop().toLowerCase()
    switch (ext) {
      case 'pdf':
        return PDFIcon
      case 'xlsx':
        return XLSXIcon
      case 'doc':
      case 'docx':
        return DOCIcon
      default:
        return UnknownFile
    }
  }
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          {NACCExtended_DATA &&
            NACCExtended_DATA.map((item, index) => {
              const isExpanded = parseInt(expanded) === parseInt(item.ID)
              return (
                <Accordion
                  key={index}
                  expanded={isExpanded}
                  onChange={handleChange(item.ID)}
                >
                  <AccordionSummary
                    style={{
                      backgroundColor: isExpanded
                        ? 'rgb(25, 47, 89)'
                        : '#D0D0D0',
                      color: isExpanded ? 'white' : 'inherit',
                    }}
                  >
                    <Typography>{item.Heading}</Typography>
                  </AccordionSummary>
                  {item?.SubHeading.map((subdata) => (
                    <AccordionDetails
                      key={subdata.ID}
                      onClick={() => handleSubheadingClick(subdata)}
                      style={{
                        backgroundColor:
                          parseInt(selectedsubHeading.ExternalID) ===
                          parseInt(subdata.ExternalID)
                            ? '#eee'
                            : 'inherit',
                        cursor: 'pointer',
                        color:
                          parseInt(selectedsubHeading.ExternalID) ===
                          parseInt(subdata.ExternalID)
                            ? 'black'
                            : 'inherit',
                      }}
                    >
                      <Typography>{subdata.Subheading}</Typography>
                    </AccordionDetails>
                  ))}
                </Accordion>
              )
            })}
        </Grid>
        <Grid item xs={12} md={9}>
          {isLoading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '200px',
              }}
            >
              <CircularProgress />
            </div>
          ) : selectedNaccData.length > 0 &&
            selectedNaccData[0]?.URLs &&
            Object.keys(selectedNaccData[0].URLs).length > 0 ? (
            Object.entries(selectedNaccData[0].URLs)
              .sort(([levelkeyA], [levelkeyB]) => {
                const numA = parseInt(levelkeyA.replace(/\D/g, ''), 10) || 0
                const numB = parseInt(levelkeyB.replace(/\D/g, ''), 10) || 0
                return numA - numB
              })
              .map(([key, levelData]) => (
                <div key={key} style={{ marginBottom: '20px' }}>
                  <Typography
                    variant="h6"
                    sx={{
                      marginBottom: '10px',
                      fontWeight: '600',
                      fontSize: '1rem',
                      color: '#333',
                    }}
                  >
                    {levelData.Title}
                  </Typography>
                  <Grid container spacing={2}>
                    {levelData.files.map((file, index) => (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        key={index}
                        sx={{ display: 'flex' }}
                      >
                        <Box
                          onClick={() => handlePdfClick(file)}
                          sx={{
                            flex: 1, // Fill remaining space in Grid item
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: 2,
                            border: '1px solid #ddd',
                            borderRadius: 2,
                            backgroundColor: '#fff',
                            boxShadow: 2,
                            transition: '0.2s',
                            height: '100%', // Match height of all cards
                            minHeight: 200, // Optional: minimum height for visual consistency
                            cursor: 'pointer',
                            '&:hover': {
                              transform: 'scale(1.05)',
                              boxShadow: 4,
                            },
                          }}
                        >
                          <img
                            src={getFileIcon(file.filename)}
                            alt="File Icon"
                            loading="lazy"
                            placeholder="blur"
                            style={{
                              width: '80px',
                              height: '80px',
                              marginBottom: '10px',
                            }}
                          />
                          <Typography
                            variant="body2"
                            sx={{
                              color: '#333',
                              textAlign: 'center',
                              wordBreak: 'break-word',
                            }}
                          >
                            {file.filename}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </div>
              ))
          ) : (
            !isLoading && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '200px',
                  color: '#666',
                }}
              >
                <Typography variant="body1">No Data Found.</Typography>
              </div>
            )
          )}
        </Grid>
      </Grid>

      <ToastContainer autoClose={3000} position="top-right" />
    </Container>
  )
}
export default NACCExtended
